import { useEffect, useState } from 'react';
import { IonGrid, IonRow, IonCol, IonInput, IonLabel, IonSelect, IonSelectOption, IonItem, IonButton, IonIcon, IonToggle } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { useForceUpdate, NumberToAlpha, TranslateAgeCode, TranslateRange } from '../../../defines/Functions';
import { Storage } from '@capacitor/storage';
import MyDatepicker from '../../MyDatepicker';
import Travelers from '../modals/Travelers';
import moment from 'jalali-moment';
import Nationality from '../../profile/modals/Nationality';
import './Step2.css';

interface Props {
    data: any,
    stepParentCallback: Function,
    passengersParentCallback: Function
}

const Step2 = (props: Props) => {
    const targetName = props.data !== null && props.data.flightDefines.targetName;
    const forceRender = useForceUpdate();
    const [data, setData] = useState([]) as any;
    useEffect(() => {
        if (props.data !== null) {
            const dataArr = [] as any;
            [...Array(props.data.flightDefines.all.passengers.adults)].forEach(_ => {
                let ageRange = TranslateRange('flight', 'ADT');
                const dataObj = {
                    gender: { value: 'm', valid: true },
                    first_name: { value: '', valid: true },
                    last_name: { value: '', valid: true },
                    birth_date: { value: ageRange.to, valid: true },
                    national_code: { value: '', valid: true },
                    nationality: { value: '', valid: true },
                    passport_code: { value: '', valid: true },
                    passport_exp_date: { value: '', valid: true },
                    type: { value: '', valid: true },
                    birth_date_range: { value: ageRange, valid: true },
                    toggle: { value: false, valid: true }
                } as any;
                if (targetName === 'International') {
                    dataObj.toggle.value = true;
                }
                dataObj.type.value = 'ADT';
                dataArr.push(dataObj);
            });
            [...Array(props.data.flightDefines.all.passengers.childs)].forEach(_ => {
                let ageRange = TranslateRange('flight', 'CHD');
                const dataObj = {
                    gender: { value: 'm', valid: true },
                    first_name: { value: '', valid: true },
                    last_name: { value: '', valid: true },
                    birth_date: { value: ageRange.to, valid: true },
                    national_code: { value: '', valid: true },
                    nationality: { value: '', valid: true },
                    passport_code: { value: '', valid: true },
                    passport_exp_date: { value: '', valid: true },
                    type: { value: '', valid: true },
                    birth_date_range: { value: ageRange, valid: true },
                    toggle: { value: false, valid: true }
                } as any;
                if (targetName === 'International') {
                    dataObj.toggle.value = true;
                }
                dataObj.type.value = 'CHD';
                dataArr.push(dataObj);
            });
            [...Array(props.data.flightDefines.all.passengers.infants)].forEach(_ => {
                let ageRange = TranslateRange('flight', 'INF');
                const dataObj = {
                    gender: { value: 'm', valid: true },
                    first_name: { value: '', valid: true },
                    last_name: { value: '', valid: true },
                    birth_date: { value: ageRange.to, valid: true },
                    national_code: { value: '', valid: true },
                    nationality: { value: '', valid: true },
                    passport_code: { value: '', valid: true },
                    passport_exp_date: { value: '', valid: true },
                    type: { value: '', valid: true },
                    birth_date_range: { value: ageRange, valid: true },
                    toggle: { value: false, valid: true }
                } as any;
                if (targetName === 'International') {
                    dataObj.toggle.value = true;
                }
                dataObj.type.value = 'INF';
                dataArr.push(dataObj);
            });
            setData(dataArr);
        }
    }, [props.data, targetName]);
    const updateData = (index: number, name: any, value: any) => {
        const dataArr = data;
        dataArr[index][name].value = value;
        setData(dataArr);
        if (name === 'toggle') {
            forceRender();
        }
    }
    const [countries, setCountries] = useState({}) as any;
    useEffect(() => {
        const getCountries = async () => {
            const { value } = await Storage.get({ key: 'countries' });
            if (value) {
                const objectValue = JSON.parse(value);
                setCountries(objectValue);
            } else {
                setCountries({});
            }
        }
        getCountries();
    }, []);
    const handleTravelerCallback = (index: number, type: string, childData: any) => {
        const dataArr = data;
        dataArr[index].gender.value = childData.gender;
        dataArr[index].first_name.value = childData.first_name_en;
        dataArr[index].last_name.value = childData.last_name_en;
        if (type === 'ADT') {
            if (moment(childData.birth_date).diff(moment('2010/01/22')) > 0) {
                dataArr[index].birth_date.value = '';
            } else {
                dataArr[index].birth_date.value = childData.birth_date;
            }
        } else if (type === 'CHD') {
            if (moment(childData.birth_date).diff(moment('2020/01/20')) > 0 || moment('2010/01/22').diff(moment(childData.birth_date)) > 0) {
                dataArr[index].birth_date.value = '';
            } else {
                dataArr[index].birth_date.value = childData.birth_date;
            }
        } else {
            if (moment(childData.birth_date).diff(moment(new Date())) > 0 || moment('2020/01/20').diff(moment(childData.birth_date)) > 0) {
                dataArr[index].birth_date.value = '';
            } else {
                dataArr[index].birth_date.value = childData.birth_date;
            }
        }
        let nationalityObj = {} as any;
        Object.values(countries).forEach((c: any) => {
            if (c.iso === childData.nationality) {
                nationalityObj = c;
            }
        })
        dataArr[index].nationality.value = nationalityObj;
        if (targetName === 'International') {
            dataArr[index].passport_code.value = childData.passport_code;
            dataArr[index].passport_exp_date.value = childData.passport_exp_date;
        } else {
            dataArr[index].national_code.value = childData.national_code;
        }
        setData(dataArr);
        forceRender();
    }
    const handleNationalityCallback = (index: number, childData: any) => {
        updateData(index, 'nationality', childData);
        forceRender();
    }
    const handleBirthDatepickerCallback = (index: number, childDataObj: any) => {
        updateData(index, 'birth_date', childDataObj.dates[0]);
    }
    const handlePassDatepickerCallback = (index: number, childDataObj: any) => {
        updateData(index, 'passport_exp_date', childDataObj.dates[0]);
    }
    const handleChange = (e: any, index: number) => {
        const name = e.target.name;
        const value = e.detail.value;
        updateData(index, name, value);
    }
    const onNextClick = () => {
        const dataArr = data;
        let formValid = true;
        dataArr.forEach((item: any, index: number) => {
            Object.entries(item).forEach((element: any) => {
                if (element[0] === 'national_code') {
                    if (item.toggle.value === true) {
                        element[1].valid = true;
                        return;
                    }
                } else if (element[0] === 'passport_code' || element[0] === 'passport_exp_date' || element[0] === 'nationality') {
                    if (item.toggle.value === false) {
                        element[1].valid = true;
                        return;
                    }
                }
                if (element[1].value) {
                    element[1].valid = true;
                } else {
                    if (element[0] === 'toggle') {
                        element[1].valid = true;
                    } else {
                        element[1].valid = false;
                        formValid = false;
                    }
                }
                dataArr[index][element[0]] = element[1];
            });
        })
        setData(dataArr);
        forceRender();
        if (formValid) {
            props.passengersParentCallback(data);
            props.stepParentCallback(3);
        }
    }
    return (
        <div className="flight-reservation-step2">
            <IonGrid>
                {data.map((item: any, index: number) =>
                    <IonRow key={"index" + index} className="ion-margin-bottom">
                        <IonCol size="12" className="step2-header">
                            <h5 className="step2-title">
                                اطلاعات مسافر {NumberToAlpha(index + 1)} - {TranslateAgeCode(item.type.value)}
                            </h5>
                            <Travelers travelerParentCallback={(value: any) => handleTravelerCallback(index, item.type.value, value)} />
                        </IonCol>
                        {targetName === 'Domestic' &&
                            <IonCol size="12" className="target-name-toggle">
                                <IonToggle color="warning" checked={data[index].toggle.value} onIonChange={e => updateData(index, 'toggle', e.detail.checked)} />
                                <IonLabel>اتباع خارجه هستم</IonLabel>
                            </IonCol>
                        }
                        <IonCol size="12">
                            <IonLabel>
                                جنسیت
                            </IonLabel>
                            <IonItem lines="none">
                                <IonLabel>جنسیت</IonLabel>
                                <IonSelect value={data[index].gender.value || ''} cancelText="لغو" okText="تایید" placeholder="انتخاب کنید" onIonChange={e => updateData(index, 'gender', e.detail.value)}>
                                    <IonSelectOption value="m">آقا</IonSelectOption>
                                    <IonSelectOption value="f">خانم</IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </IonCol>
                        <IonCol size="12">
                            <IonLabel>
                                نام به انگلیسی
                                {!data[index].first_name.valid ? <span className="required">الزامی</span> : null}
                            </IonLabel>
                            <IonInput type="text" name="first_name" value={data[index].first_name.value || ''} onIonChange={(e) => handleChange(e, index)} />
                        </IonCol>
                        <IonCol size="12">
                            <IonLabel>
                                نام خانوادگی به انگلیسی
                                {!data[index].last_name.valid ? <span className="required">الزامی</span> : null}
                            </IonLabel>
                            <IonInput type="text" name="last_name" value={data[index].last_name.value || ''} onIonChange={(e) => handleChange(e, index)} />
                        </IonCol>
                        <IonCol size="12">
                            <IonLabel>
                                تاریخ تولد
                                ({data[index].birth_date_range.value.label})
                                {!data[index].birth_date.valid ? <span className="required">الزامی</span> : null}
                            </IonLabel>
                            <MyDatepicker
                                value={data[index].birth_date.value ? data[index].birth_date.value : null}
                                isGregorian={true}
                                isRange={false}
                                datepickerParentCallback={(value: any) => handleBirthDatepickerCallback(index, value)}
                                maxDate={data[index].birth_date_range.value.to}
                                minDate={data[index].birth_date_range.value.from}
                            />
                        </IonCol>
                        {!data[index].toggle.value ?
                            <IonCol size="12">
                                <IonLabel>
                                    کد ملی
                                    {!data[index].national_code.valid ? <span className="required">الزامی</span> : null}
                                </IonLabel>
                                <IonInput type="text" name="national_code" value={data[index].national_code.value || ''} onIonChange={(e) => handleChange(e, index)} />
                            </IonCol>
                            :
                            <>
                                <IonCol size="12">
                                    <IonLabel>
                                        ملیت
                                        {!data[index].nationality.valid ? <span className="required">الزامی</span> : null}
                                    </IonLabel>
                                    <Nationality
                                        nationalityParentCallback={(value: any) => handleNationalityCallback(index, value)}
                                        inputValue={data[index].nationality.value || ''}
                                    />
                                </IonCol>
                                <IonCol size="12">
                                    <IonLabel>
                                        شماره پاسپورت
                                        {!data[index].passport_code.valid ? <span className="required">الزامی</span> : null}
                                    </IonLabel>
                                    <IonInput type="text" name="passport_code" value={data[index].passport_code.value || ''} onIonChange={(e) => handleChange(e, index)} />
                                </IonCol>
                                <IonCol size="12">
                                    <IonLabel>
                                        تاریخ انقضای پاسپورت (بعد از 2022/08/20)
                                        {!data[index].passport_exp_date.valid ? <span className="required">الزامی</span> : null}
                                    </IonLabel>
                                    <MyDatepicker
                                        value={data[index].passport_exp_date.value}
                                        isGregorian={true}
                                        isRange={false}
                                        datepickerParentCallback={(value: any) => handlePassDatepickerCallback(index, value)}
                                        minDate={new Date("2022/08/20")}
                                    />
                                </IonCol>
                            </>
                        }
                    </IonRow>
                )}
            </IonGrid>
            <IonButton color="warning" className="btn-next" onClick={onNextClick}>
                مرحله بعد
                <IonIcon icon={arrowBack} />
            </IonButton>
        </div>
    );
};
export default Step2;